<template>
  <div class="surveyDetails">
    <div class="row">
      <div class="col-md-12 top">
        <router-link class="return" :to="{
            name: 'List Surveys'
          }">
          <i class="fas fa-chevron-left"></i>
          {{ $t("events.newEvent.back") }}
        </router-link>
      </div>
    </div>
    <h1>{{ $t("surveys.newSurvey.details") }} {{ this.$route.params.surveyObj.name }}</h1>
    <button
      v-if="this.$route.params.surveyObj.surveyPercentAnswers !== 0"
      @click="downloadExcel"
      class="btn btn-download-excel"
    >{{ $t("surveys.newSurvey.download") }} .xlsx</button>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <div class="grafica">
          <h1 class="mr-5">{{ $t("surveys.newSurvey.participate") }}</h1>
          <apexchart
            type="pie"
            width="100%"
            height="250"
            :options="graphic1.chartOptions"
            :series="graphic1.series"
          ></apexchart>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="grafica">
          <h1 class="mr-5">{{ $t("surveys.newSurvey.status") }}</h1>
          <apexchart
            type="pie"
            width="100%"
            height="250"
            :options="graphic2.chartOptions"
            :series="graphic2.series"
          ></apexchart>
        </div>
      </div>
    </div>
    <v-server-table
      :columns="table_options.columns"
      :options="table_options.options"
      ref="userTable"
    ></v-server-table>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/Surveys.js";
const api = new API_SERVICE();

export default {
  data() {
    return {
      graphic1: {
        series: [44, 55],
        chartOptions: {
          chart: {
            width: 400,
            type: "pie",
          },
          legend: {
            position: "right",
          },
          labels: [
            this.$t("surveys.newSurvey.statsParticipate"),
            this.$t("surveys.newSurvey.statsNoParticipate"),
          ],
          responsive: [
            {
              breakpoint: 1440,
              options: {
                chart: {
                  width: 400,
                },
                legend: {
                  position: "left",
                },
              },
            },
          ],
          colors: ["#333333", "#d9d9d9"],
          states: {
            hover: {
              filter: {
                type: "none",
              },
            },
          },
        },
      },
      graphic2: {
        series: [60, 20],
        chartOptions: {
          chart: {
            width: 500,
            type: "pie",
          },
          labels: [
            this.$t("surveys.newSurvey.statsCompleted"),
            this.$t("surveys.newSurvey.statsNoCompleted"),
          ],
          responsive: [
            {
              breakpoint: 1440,
              options: {
                chart: {
                  width: 500,
                },
                legend: {
                  position: "left",
                },
              },
            },
          ],
          colors: ["#333333", "#bb0a30"],
          states: {
            hover: {
              filter: {
                type: "none",
              },
            },
          },
        },
      },
      answers: [],
      stats: {
        answered: [],
        status: [],
      },
      columns: [
        "gender",
        "status",
        "workingShift",
        "dailyWorkingShift",
        "substitutionWorkingShift",
        "directBossControlNumber",
        "maritalStatus",
        "idUo",
        "numberOfChildren",
        "type",
        "typeDescription",
        "uo",
        "uoDescription",
      ],
    };
  },
  methods: {
    dataFormat: function (a, b) {
      if (b) return b + "%";
      return a;
    },
    getGraphics: async function () {
      let params = {
        userData:
          "uo,uo_description,id_uo,direct_boss_control_number,gender,status,type,type_description,working_shift,daily_working_shift,substitution_working_shift,marital_status,number_of_children",
        requestResponse: "data",
      };
      const resp = await api.getSurveyStats(this.$route.params.id, params);
      console.log('----------------------------------------------------')
      console.log(resp)
      //LLenado de headers
      this.fillColumns(resp.surveyData.answers);
      //Llenado de headers close
      this.stats.answered = [
        +resp.surveyData.answered.answers,
        +resp.surveyData.answered.notAnswered,
      ];
      this.stats.status = [
        +resp.surveyData.status.completed,
        +resp.surveyData.status.notAnswered,
      ];

      this.graphic1.series = this.stats.answered;
      this.graphic2.series = this.stats.status;
    },
    downloadExcel: async function () {
      let params = {
        userData:
          "uo,uo_description,id_uo,direct_boss_control_number,gender,status,type,type_description,working_shift,daily_working_shift,substitution_working_shift,marital_status,number_of_children",
        requestResponse: "excel",
      };
      const resp = await api.getSurveyStats(this.$route.params.id, params);
      let anchor = document.createElement("a");
      anchor.href = resp.url;
      anchor.target = "_blank";
      anchor.click();
    },
    fillColumns: function (response) {
      if (this.$route.params.surveyObj.anonymous) {
        let array = [];
        for (const key in response[0]) {
          if (key !== "questions") {
            array.push(key);
          }
        }
        let keyQuestion = response[0].questions.map(
          (question) => question.question
        );
        array.push(...keyQuestion);

        this.columns = array;
      } else {
        // question.question
        let keyQuestion = response[0].questions.map((question, index) =>
          question.question.replace(".", "")
        );
        this.columns = this.columns.concat(keyQuestion);
      }
    },
  },
  beforeMount: function () {
    this.getGraphics();
  },
  computed: {
    userTable: function () {
      return this.$refs.userTable;
    },
    table_columns: function () {
      return this.columns;
    },
    table_headings: function () {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach((column) => {
          if (this.$t(`users.manage.table.headings`).hasOwnProperty(column)) {
            headings[column] = this.$t(`users.manage.table.headings.${column}`);
          } else {
            headings[column] = column;
          }
        });
        return headings;
      }
      return null;
    },
    table_filters: function () {
      return this.table_columns.filter((column) => column !== "actions");
    },
    table_options: function () {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: false,
          resizableColumns: false,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          perPage: 10,
          columnsClasses: {
            actions: "actions-column",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.manage.table.column_toggler"),
          },

          requestAdapter: function (data) {
            const queries = {};
            queries.page = data.page - 1;
            queries.limit = data.limit;
            queries.query = data.query;
            return queries;
          },
          requestFunction: async function () {
            this.$store.commit("global/SET_LOADING", true);
            try {
              let params = {
                userData:
                  "uo,uo_description,id_uo,direct_boss_control_number,gender,status,type,type_description,working_shift,daily_working_shift,substitution_working_shift,marital_status,number_of_children",
                requestResponse: "data",
              };
              const resp = await api.getSurveyStats(
                this.$route.params.id,
                params
              );
              this.$store.commit("global/SET_LOADING", false);

              return resp.surveyData.answers;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              throw error;
            }
          },
          responseAdapter: function (response) {
            let array = response[0].questions.map(
              (question) => question.question
            );

            for (let index = 0; index < response.length; index++) {
              let obj = {};
              for (
                let index2 = 0;
                index2 < response[index].questions.length;
                index2++
              ) {
                obj[
                  response[index].questions[index2].question.replace(".", "")
                ] = response[index].questions[index2].answer;
              }

              delete response[index].questions;

              response[index] = Object.assign({}, response[index], obj);
            }

            console.log(response, "response");
            /*  this.columns = this.columns.concat(array); */
            //
            return {
              data: response,
              count: response.length,
            };
          },
        },
      };
    },
  },
};
</script>
<style >
.return {
  color: black;
  cursor: pointer;
}
.return:hover {
  color: black;
  text-decoration: underline !important;
}
.btn-download-excel {
  border-radius: 0 !important;
  background-color: #000 !important;
  color: #ffffff !important;
  margin-bottom: 2rem !important;
}
</style>
<style>
@media (min-width: 768px) and (max-width: 1400px) {
  .rr {
    margin-right: 3rem;
  }
}
</style>
<style lang="scss">
.grafica {
  background: #ffffff;
  padding: 2rem;
  text-align: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}
.pull-right {
  float: none !important;
}
.VueTables .dropdown {
  margin: 1rem 0;
}
.VueTables__columns-dropdown > button {
  @extend %audi;
  color: $black !important;
  background-color: transparent !important;
  border: 1px solid $black !important;
  border-radius: 0 !important;
  padding: 5px 10px !important;
}
.VueTables .dropdown .dropdown-menu {
  padding: 1rem;
  a {
    color: $black;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  a > input {
    margin-right: 0.5rem;
  }
}
.VueTables__table.table {
  min-width: 100%;
  width: max-content;
}
.VueTables__table .actions-column {
  position: sticky;
  right: 0;
  text-align: center;
  &:after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: #f2f2f2;
    top: 0;
    right: 0;
    border-collapse: collapse;
  }
}
.apexcharts-legend {
  top: 70px !important;
}

.VueTables__table .actions-column > * {
  position: relative;
  z-index: 1;
}
.table-striped tbody tr:nth-of-type(odd) > .actions-column {
  &:after {
    background-color: #e6e6e6;
  }
}
.VueTables__table .id-column {
  max-width: 100px;
}
[class$="filter-wrapper"] {
  min-width: 80px;
  max-width: fit-content;
}
.surveyDetails .VueTables__search {
  display: none !important;
}
</style>
